import { DesignMapper } from '../mapper/desing.mapper';
import { DesignDto } from '../models/dataTransferObjects/design.dto';

export class DesignService {
    public async GetDesing(bussinessToken: string): Promise<DesignDto> {
        const data = await fetch(`https://api-design-dot-simplepago-staging.uc.r.appspot.com/api/v1/design/${bussinessToken}`)
        return DesignMapper.toDto(await data.json());
    }
}
